<template>
    <el-dialog title="选择文件" top="30px" :visible.sync="visible" width="800px" :close-on-click-modal="false">
        <el-row type="flex" style="margin-top: -20px" justify="space-between">
            <div></div>
            <div>
                <el-input
                    size="small"
                    style="width: 300px; margin-right: 10px"
                    v-model="query.search_keyword"
                    placeholder="文件名称"
                    clearable
                    suffix-icon="el-icon-search"
                    @keyup.enter.native="handleSearch"
                />
                <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
            </div>
        </el-row>
        <ListPage
            ref="listPage"
            :search="false"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
            @selection-change="handleSelectionChange"
        >
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="序号" align="center" type="index" width="80" />
                <el-table-column label="文件标题" align="center" prop="name" />
                <el-table-column label="分类" align="center" prop="mgroup.name" />
                <el-table-column label="时间" align="center" prop="create_time" width="160" />
            </template>
        </ListPage>
        <el-form style="margin-top: 20px">
            <el-form-item label="支持下载人群">
                <el-radio-group v-model="type">
                    <el-radio :label="1">注册用户</el-radio>
                    <el-radio :label="2">特殊标签用户</el-radio>
                </el-radio-group>
                <LabelSelector style="margin-left: 10px" v-if="type == 2" v-model="label" multiple></LabelSelector>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { list } from "@/api/file/list";
import listMixin from "@/mixins/list";
import LabelSelector from "@/components/LabelSelector";
export default {
    components: { LabelSelector },
    props: {
        lang: {
            type: String,
            default: "zh",
        },
    },
    data() {
        return {
            query: {
                search_keyword: "",
            },
            visible: false,
            loading: false,
            options: [],
            ids: [],
            ids_d: [],
            picks: [],
            names: [],
            type: "",
            label: "",
        };
    },
    mixins: [listMixin],
    methods: {
        open() {
            this.visible = true;
            this.picks = [];
            this.search();
        },
        close() {
            this.visible = false;
        },
        search() {
            this.loading = true;
            const params = {
                ...this.query,
                lang: this.lang,
            };
            list(params).then(({ code, result, msg }) => {
                if (code === 200) {
                    this.tableData = result.data;
                    this.total = result.total;
                    this.setChecks();
                } else {
                    this.$message.error(msg);
                }
                this.loading = false;
            });
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        merge() {
            this.ids.forEach((x) => {
                if (!this.picks.find((n) => n.uuid == x)) {
                    this.picks.push(this.names.find((n) => n.uuid == x));
                }
            });
            this.ids_d.forEach((x) => {
                if (this.picks.find((n) => n.uuid == x)) {
                    this.picks = this.picks.filter((y) => y.uuid !== x);
                }
            });
        },
        setChecks() {
            this.tableData.map((x) => {
                if (this.picks.find((n) => n.uuid == x.uuid)) {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, true);
                    });
                } else {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, false);
                    });
                }
            });
        },
        handleConfirm() {
            if (this.picks.length === 0) {
                this.$message.warning("请选择文件");
                return;
            }
            if (this.type == 2 && !this.label) {
                this.$message.warning("请选择标签");
                return;
            }
            this.$emit("pick", JSON.parse(JSON.stringify(this.picks.map((x) => ({ ...x, type: this.type, label: this.label })))));
            this.visible = false;
        },
    },
};
</script>

<style></style>
